import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { money } from "../lib/api";
import { Card } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { TrendingUp } from "lucide-react";

export default function AnalystHistoryDialog({ analystId, open, onOpenChange }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (open && analystId) {
      api.get(`/analysts/${analystId}/history`).then(r => setData(r.data)).catch(() => {});
    } else { setData(null); }
  }, [open, analystId]);

  if (!open) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><TrendingUp size={18} className="text-primary" /> Histórico — {data?.analyst?.name}</DialogTitle></DialogHeader>
        {data && (
          <div className="space-y-4">
            <div style={{ width: "100%", height: 260 }}>
              <ResponsiveContainer>
                <LineChart data={data.series}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                  <XAxis dataKey="mes" stroke="#64748B" fontSize={12} />
                  <YAxis stroke="#64748B" fontSize={12} />
                  <Tooltip formatter={v => money(v)} />
                  <Legend />
                  <Line type="monotone" dataKey="meta" name="Meta" stroke="#94A3B8" strokeDasharray="5 5" strokeWidth={2} dot={false} />
                  <Line type="monotone" dataKey="realizado" name="Realizado" stroke="#2563EB" strokeWidth={2} dot={{ r: 4 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-left text-slate-600"><tr><th className="py-2 px-3">Mês</th><th>Meta</th><th>Realizado</th><th>% Atingido</th><th>Horas</th></tr></thead>
                <tbody>
                  {data.series.map(s => {
                    const pct = s.meta > 0 ? Math.round((s.realizado / s.meta) * 100) : null;
                    return (
                      <tr key={s.mes} className="border-t border-slate-100">
                        <td className="py-2 px-3 font-medium">{s.mes}</td>
                        <td>{s.meta > 0 ? money(s.meta) : "—"}</td>
                        <td className="font-medium text-primary">{money(s.realizado)}</td>
                        <td>{pct != null ? <span className={pct >= 100 ? "text-emerald-700 font-medium" : "text-slate-600"}>{pct}%</span> : "—"}</td>
                        <td>{s.horas.toFixed(1)}h</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Fechar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
